import styled from 'styled-components'
import {
  white,
  blue,
  red,
  grayLight,
  grayLighter,
} from '@bufferapp/ui/style/colors'

import { flexRow } from '~/shared/styles/layout'
import { lila, black } from '~/shared/styles/colors'
import { fadeIn } from '~/shared/styles/animations'
import { baseFont } from '~/shared/styles/font'

/**
 *
 */
const POST_WRAPPER_CONTENT_DIFF = 16

export const Wrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`

export const GridWrapper = styled.div`
  width: 100%;
  padding: 8px;
`

export const Row = styled.div`
  ${flexRow}
  justify-content: start;
  align-items: start;
  width: 100%;
`

export const PostWrapper = styled.div`
  width: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'width' does not exist on type 'ThemedSty... Remove this comment to see the full error message
    props.width}px;
  height: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'height' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.height}px;
  padding: 8px;
  background: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'selected' does not exist on type 'Themed... Remove this comment to see the full error message
    props.selected ? lila : white};
  border-radius: 9px;
  cursor: pointer;
`

export const ContentWrapper = styled.div`
  position: relative;
  width: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'width' does not exist on type 'ThemedSty... Remove this comment to see the full error message
    props.width - POST_WRAPPER_CONTENT_DIFF}px;
  height: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'height' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.height - POST_WRAPPER_CONTENT_DIFF}px;
  border-radius: 3px;
  box-shadow: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'selected' does not exist on type 'Themed... Remove this comment to see the full error message
    props.selected ? `0 0 0 3px ${blue}` : 'none'};
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
  border-radius: 6px;
  display: block;

  ${PostWrapper}:hover & {
    display: none;
  }
`

export const TextWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  padding: 8px;
  line-height: 16px;
`

export const IndicatorsWrapper = styled.div`
  position: absolute;
  bottom: 8px;
  left: 8px;
  ${flexRow};
`

export const CommentsWrapper = styled.div`
  background: ${red};
  border-radius: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'standalone' does not exist on type 'Them... Remove this comment to see the full error message
    props.standalone ? '4px' : '4px 0px 0px 4px'};
  color: ${white};
  padding: 4px;
`

export const LabelsWrapper = styled.div`
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0px 4px 4px 0px;
  padding: 4px 4px 4px 0px;
  ${flexRow}

  & > div {
    margin-left: 4px;
  }
`

export const Placeholder = styled.div`
  width: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'width' does not exist on type 'ThemedSty... Remove this comment to see the full error message
    props.width - POST_WRAPPER_CONTENT_DIFF}px;
  height: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'height' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.height - POST_WRAPPER_CONTENT_DIFF}px;
  margin: 8px;
  background: ${grayLight};
  border-radius: 4px;
  ${fadeIn}
`

export const FilterWrapper = styled.div`
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;
  background-color: ${grayLighter};
  border-radius: 4px;
  ${flexRow}
  justify-content: space-between;
  align-items: center;
`

export const FilterMessage = styled.div`
  ${flexRow}
  & > * {
    margin-right: 8px;
  }
`

export const CommentCount = styled.span`
  ${baseFont}
  font-weight: bold;
  color: ${black};
  margin-right: 4px;
`
